import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import TipoDocumentoSerieConstant from 'constants/tipoDocumentoSerie'

import * as SedeService from 'services/sede.service'

import * as Modals from './modals'

const tableHeaderRows = [{ label: 'TIPO DOC.' }, { label: 'SERIE', width: 80 }, { label: 'NUM. INICIAL', width: 120 }, { label: '', width: 60 }]

const ListaSubMediosPagoPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const tablaRef = React.useRef(null)
  const editarData = React.useRef({})

  const [mostrarCrearEditarModal, setMostrarCrearEditarModal] = React.useState(false)

  const clickNuevo = React.useCallback(() => {
    editarData.current = {}
    setMostrarCrearEditarModal(true)
  }, [])

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      await SedeService.getSerie(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarCrearEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await SedeService.eliminarSerie(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.tipoSerie ? TipoDocumentoSerieConstant.__dictionary[row.tipoSerie].nombre : '--'}</Table.Cell>
        <Table.Cell>{row.serie}</Table.Cell>
        <Table.Cell>{row.numeroInicial}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [clickEditar, clickEliminar]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Series' buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
        <Portlet.Body>
          <Table.ServerSide useNest={true} ref={tablaRef} url='/sedes/series' headRows={tableHeaderRows} rowTemplate={rowTemplate} />
        </Portlet.Body>
      </Portlet>
      {mostrarCrearEditarModal && (
        <Modals.CrearEditarModal
          handleClose={e => setMostrarCrearEditarModal(false)}
          show={mostrarCrearEditarModal}
          reloadTable={tablaRef.current.reload}
          editarData={editarData.current}
        />
      )}
    </>
  )
}

export default ListaSubMediosPagoPage
